var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ml-spinner",attrs:{"role":"status","aria-label":"Loading..."}},[_c('span',{class:['ml-spinner-icon', _vm.sizeClass]}),(_vm.label)?_c('span',{staticClass:"ml-spinner-text"},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }